import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { BRAND, errMsg, inr, today } from "./constants";

const NEXT = { enquiry: ["confirmed", "cancelled"], confirmed: ["checked_in", "cancelled"], checked_in: ["checked_out"], checked_out: [], cancelled: [] };
const LABEL = { confirmed: "Confirm", cancelled: "Cancel", checked_in: "Check in", checked_out: "Check out" };

export function BookingsPanel({ pid, authFetch, API, onChange }) {
  const [items, setItems] = useState([]);
  const [beds, setBeds] = useState([]);
  const [f, setF] = useState({ guest_name: "", guest_phone: "", bed_id: "", check_in: today(), check_out: "", amount_inr: "", status: "enquiry", plan: "monthly" });

  const load = useCallback(() => {
    authFetch({ url: `${API}/homestay/properties/${pid}/bookings` }).then((r) => setItems(r.data.items)).catch(() => {});
    authFetch({ url: `${API}/homestay/properties/${pid}/board` }).then((r) => setBeds(r.data.rooms.flatMap((rm) => rm.beds))).catch(() => {});
  }, [pid, authFetch, API]);
  useEffect(() => { load(); }, [load]);

  const add = async (e) => {
    e.preventDefault();
    try {
      await authFetch({ method: "post", url: `${API}/homestay/properties/${pid}/bookings`, data: { ...f, amount_inr: +f.amount_inr, bed_id: f.bed_id || null, guest_phone: f.guest_phone || null, check_out: f.check_out || null } });
      toast.success("Booking added");
      setF({ ...f, guest_name: "", guest_phone: "", amount_inr: "", bed_id: "" }); load(); onChange();
    } catch (err) { toast.error(errMsg(err, "Could not add booking")); }
  };
  const move = async (id, status) => {
    try { await authFetch({ method: "patch", url: `${API}/homestay/bookings/${id}`, data: { status } }); load(); onChange(); }
    catch (err) { toast.error(errMsg(err, "Could not update booking")); }
  };

  const cls = "rounded-xl border-2 px-2.5 py-2 text-sm w-full";
  return (
    <div data-testid="bookings-panel" className="rounded-2xl border-2 bg-white p-4" style={{ borderColor: BRAND.line }}>
      <div className="text-sm font-bold" style={{ color: BRAND.green }}>Bookings pipeline</div>
      <form onSubmit={add} className="mt-3 grid grid-cols-2 gap-2">
        <input required placeholder="Guest name" data-testid="booking-guest-name" className={cls} value={f.guest_name} onChange={(e) => setF({ ...f, guest_name: e.target.value })} />
        <input placeholder="Phone" data-testid="booking-guest-phone" className={cls} value={f.guest_phone} onChange={(e) => setF({ ...f, guest_phone: e.target.value })} />
        <select data-testid="booking-bed" className={cls} value={f.bed_id} onChange={(e) => setF({ ...f, bed_id: e.target.value })}>
          <option value="">No bed yet</option>
          {beds.filter((b) => b.status === "vacant").map((b) => <option key={b.id} value={b.id}>{b.label}</option>)}
        </select>
        <input required type="number" min={0} placeholder="Amount ₹" data-testid="booking-amount" className={cls} value={f.amount_inr} onChange={(e) => setF({ ...f, amount_inr: e.target.value })} />
        <input required type="date" data-testid="booking-checkin" className={cls} value={f.check_in} onChange={(e) => setF({ ...f, check_in: e.target.value })} />
        <select data-testid="booking-status" className={cls} value={f.status} onChange={(e) => setF({ ...f, status: e.target.value })}>
          <option value="enquiry">Enquiry</option><option value="confirmed">Confirmed</option>
        </select>
        <select data-testid="booking-plan" className={cls} value={f.plan} onChange={(e) => setF({ ...f, plan: e.target.value })}>
          <option value="monthly">Monthly</option><option value="nightly">Per day</option>
        </select>
        <input type="date" data-testid="booking-checkout" className={cls} value={f.check_out} onChange={(e) => setF({ ...f, check_out: e.target.value })} title="Check-out date" />
        <button data-testid="booking-submit" className="col-span-2 rounded-full py-2 text-sm font-bold text-white" style={{ background: BRAND.green }}>Add booking</button>
      </form>
      <div className="mt-3 max-h-64 overflow-y-auto divide-y" data-testid="bookings-list">
        {items.length === 0 && <div className="text-xs py-3" style={{ color: BRAND.muted }}>No bookings yet.</div>}
        {items.map((b) => (
          <div key={b.id} data-testid={`booking-row-${b.id}`} className="py-2 text-sm flex items-center justify-between gap-2">
            <div className="min-w-0">
              <b>{b.guest_name}</b> <span className="text-xs" style={{ color: BRAND.muted }}>{b.check_in}{b.check_out ? ` → ${b.check_out}` : ""} · {inr(b.amount_inr)} · {b.plan === "nightly" ? "per day" : "monthly"}</span>
              <div className="text-[10px] uppercase tracking-widest font-bold" style={{ color: BRAND.orange }} data-testid={`booking-status-${b.id}`}>{b.status.replace("_", " ")}</div>
            </div>
            <div className="flex gap-1 shrink-0">
              {NEXT[b.status].map((s) => (
                <button key={s} data-testid={`booking-${s}-${b.id}`} onClick={() => move(b.id, s)} className="rounded-full border px-2.5 py-1 text-[11px] font-bold"
                  style={{ borderColor: s === "cancelled" ? "#DC2626" : BRAND.green, color: s === "cancelled" ? "#DC2626" : BRAND.green }}>{LABEL[s]}</button>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
